import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.SoilAndRockMass`]: wrap([`${prefix}.TareMass`, `${prefix}.SoilRockAndTareMass`]),
  [`${prefix}.RockMass`]: wrap([`${prefix}.TareMass`, `${prefix}.TareAndRockMass`]),
});

export default getDerivedFromMeasurementsConfig;
